import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import {styled} from '@mui/material/styles';

const BackgroundPaper = styled(Box)(({theme, background}) => ({
  backgroundColor: background
    ? background?.light
      ? background?.light
      : background
    : theme.palette.background.paper,
  ...theme.applyStyles('dark', {
    backgroundColor: background?.dark
      ? background?.dark
      : theme.palette.background.paper,
  }),
}));

BackgroundPaper.propTypes = {
  background: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  // if string -> background is applied to light mode and auto color is applied to dark mode
  // if object -> background.light is applied to light mode and background.dark is applied to dark mode
};

export default BackgroundPaper;
